import { Component, OnDestroy, OnInit } from '@angular/core';
import { DwSecurityUserService } from '@devwareapps/devware-cap';
import { ProductPreview } from '../../models/product-preview.models';
import { combineLatest, Subscription } from 'rxjs';
import { shareReplay, take } from 'rxjs/operators';
import { DwProductEntity } from '../../../../meta-data/app-meta-data.service';
import { ChallengeCatalog, FitnessReferenceDataService, challengeRegistrationPrice } from '../../services/fitness-reference-data.service';
import { FitnessCommerceService } from '../../../commerce/services/fitness-commerce.service';

@Component({ selector: 'app-fitness-store', templateUrl: './store.component.html',
    styleUrls: ['../challenge-registration/challenge-registration.component.scss', './store.component.scss'] })
export class FitnessStoreComponent implements OnInit, OnDestroy {
    catalog: ChallengeCatalog;
    gear: DwProductEntity[] = [];
    donations: DwProductEntity[] = [];
    previews: { [id: number]: ProductPreview } = {};
    loading = true;
    error = '';
    private sub = new Subscription();
    constructor(private data: FitnessReferenceDataService, public security: DwSecurityUserService, public commerce: FitnessCommerceService) {}
    get authenticated(): boolean { return !!this.security.securityState.isAuthenticated; }
    get registrationPrice(): number { return challengeRegistrationPrice(this.catalog?.challenge); }
    private inWindow(start: string, end: string): boolean {
        return !!start && !!end && Date.now() >= Date.parse(start) && Date.now() <= Date.parse(end);
    }
    get storeOpen(): boolean { return !!this.catalog && this.inWindow(this.catalog.challenge.StoreStartDate, this.catalog.challenge.StoreEndDate); }
    get registrationOpen(): boolean { return this.storeOpen && this.inWindow(this.catalog.challenge.RegistrationStartDate, this.catalog.challenge.RegistrationEndDate); }
    ngOnInit(): void {
        const products = this.data.getProducts().pipe(take(1), shareReplay(1));
        this.sub.add(combineLatest([this.data.getActiveChallengeCatalog(), products, this.data.getProductTypes()]).pipe(take(1))
            .subscribe(([catalog, items, types]) => {
                this.catalog = catalog;
                const type = (p: DwProductEntity) => types.find(t => t.ProductTypeId === p.ProductTypeId)?.ProductType;
                this.gear = items.filter(p => type(p) === 'Gear' && p.ProductDefaultPrice != null && Number.isFinite(p.ProductDefaultPrice) && p.ProductDefaultPrice >= 0 &&
                    (this.registrationOpen || !(/shirt/i.test(p.ProductName) || catalog.products.some(link => link.includedInChallenge && link.product.ProductId === p.ProductId))));
                this.donations = items.filter(p => type(p) === 'Donation');
                this.loading = false;
                this.sub.add(this.data.getProductPreviews([...items.map(p => p.ProductId), catalog.challenge.ProductId]).subscribe(previews => this.previews = previews, () => {}));
            }, () => { this.loading = false; this.error = 'Unable to load the store. Please reload to try again.'; }));
    }
    ngOnDestroy(): void { this.sub.unsubscribe(); }
}
